// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import dependencies
//
import "phoenix_html"

// Import local files
//
// Local files can be imported directly using relative paths, for example:
// import socket from "./socket"

import "react-phoenix"

// Import local files
//
// Local files can be imported directly using relative
// paths "./socket" or full ones "web/static/js/socket".

// import socket from "./socket"


// start of alpine
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()
// end of alpine

import "./live-view";

// popper tooltip activation
// $(function () {
//   $('[data-toggle="tooltip"]').tooltip();
//   $('[data-toggle="popover"]').popover();
// })

import {Welcome} from "./components/foo"
import JSErrorComponent from './components/js_error_component';

window.Components = {
  Welcome,
  JSErrorComponent,
}
